import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceTaskStatusEditionNotificationState = createStateReducer(
  initialState,
  {
    [events.editTaskStatusSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editTaskStatus",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.editTaskStatusFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "editTaskStatus",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceTaskStatusEditionNotificationState };
